import * as React from 'react'
import classnames from 'classnames'
import { NO_DATA } from '@App/constantes'
import './style.scss'

const NoData = (props: any) => {
  const { customClass, title, description } = props

  return (
    <div className={classnames('noData', customClass !== null ? customClass : null)}>
      <div className="doubleBlock">
        <div className="imageBlock">
          <div className="emptyImage" />
        </div>
        <div className="textBlock">
          <div className="title">
            {title || NO_DATA}
          </div>
          <div className="description">
            {description || 'No data'}
          </div>
        </div>
      </div>
    </div>
  )
}

export default NoData
